import { useRef, useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { VIDEO } from 'hb-react/shared/components/DesignSystem/QuillEditor/constants';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import { MIME_TYPE_VIDEOS } from 'hb-react/shared/constants/mimeTypeVideos';

import InputFileHidden from '../components/InputFileHidden';
import ToolbarItem from '../components/ToolbarItem';
import getFileInputClickHandler from '../utils/getFileInputClickHandler';

// @see config/hivebrite_storage.yml
export const ACCEPT_VIDEOS = MIME_TYPE_VIDEOS;

const Video = () => {
  const { onAddFiles, options, setForceEditorFocus } = useQuillEditorContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const { toolbar: toolbarOptions, tooltips: tooltipsOptions } = options ?? {};

  const handleAddVideo = useCallback(
    (files) => {
      onAddFiles?.({
        type: VIDEO,
        files,
      });

      setForceEditorFocus?.(false);
    },
    [onAddFiles, setForceEditorFocus],
  );

  return (
    <>
      <ToolbarItem
        onMouseDown={() => setForceEditorFocus?.(true)}
        onClick={getFileInputClickHandler(inputRef)}
        icon={<FontAwesomeIcon iconName="circle-play" height="16px" />}
        disabled={
          typeof toolbarOptions?.video === 'object'
            ? toolbarOptions?.video?.disabled
            : false
        }
        dataTestId="video-action"
        ariaLabel={s__('QuillEditorAccessibility|Add a video')}
        tooltip={tooltipsOptions?.images}
        enableFontAwesomeIcon
      />
      <InputFileHidden
        ref={inputRef}
        dataTestId="video-action-input"
        accept={ACCEPT_VIDEOS}
        onChange={handleAddVideo}
      />
    </>
  );
};

export default Video;
